// extracted by mini-css-extract-plugin
export default {"modalOverlay":"YD-z","modalContent":"ZD-z","header":"_D-z","close":"aE-z"};